/**
 * Custom — compose your own configuration from what actually exists.
 *
 * Custom supports existing composed setups (the backfill target for
 * ambiguous pre-213 projects). It is NOT a dump of every setting: the
 * dashboard shows real capabilities, prerequisites, project bindings,
 * governance and project context, with controlled advanced setup.
 */
import type { UseCaseDefinition } from "../types";

export const customUseCase: UseCaseDefinition = {
  id: "custom",
  version: 1,
  labelKey: "useCases.custom.label",
  shortDescriptionKey: "useCases.custom.short",
  fullDescriptionKey: "useCases.custom.full",
  primaryOutcomeKey: "useCases.custom.outcome",
  availability: "available",
  applicableWorkProfiles: ["support", "engineering", "release_devops", "manager_reviewer", "admin", "custom"],
  requiredCapabilities: [],
  recommendedCapabilities: ["approvals.route"],
  suggestedBindingPurposes: [
    "intake",
    "approvals",
    "notifications",
    "status",
    "delivery",
    "deployment",
    "incidents",
    "code",
  ],
  onboardingStepIds: ["custom.advanced-setup"],
  dashboardSectionIds: [
    "custom.capabilities",
    "custom.context",
    "shared.approvals",
    "shared.activity",
  ],
  readinessCheckIds: ["custom.any-context"],
  prerequisiteDescriptionKeys: ["useCases.custom.prereq.context"],
};
